import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  standalone: true,
  selector: 'equine-ui-nx-ach-acceptance',
  templateUrl: './ach-acceptance.component.html',
  styleUrls: ['./ach-acceptance.component.scss'],
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    MatButtonModule
  ]
})
export class AchAcceptanceComponent {

  openedFiles = signal<string[]>([]);

  @Output() confirmed = new EventEmitter<void>();
  public accepted = false;

  confirm() {
    this.confirmed.emit();
  }

  openFile(index: string) {
    this.openedFiles.set([...this.openedFiles(), index]);
  }

}
